import revive_payload_client_4sVQNw7RlN from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import navigation_repaint_client_bs2bWDGRIE from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/disk2/server/proxy-front-ssr/dists/sx/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_UYiXMU8ZyN from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import element_plus_teleports_plugin_h4Dmekbj62 from "/disk2/server/proxy-front-ssr/dists/sx/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/disk2/server/proxy-front-ssr/dists/sx/.nuxt/element-plus-injection.plugin.mjs";
import init_grdyAU8lhf from "/disk2/server/proxy-front-ssr/dists/sx/plugins/init.ts";
import critical_resources_vWgJPk8Gbv from "/disk2/server/proxy-front-ssr/dists/sx/plugins/critical-resources.ts";
import error_handler_kEP5FliEXj from "/disk2/server/proxy-front-ssr/dists/sx/plugins/error-handler.ts";
import accessibility_zajbwEjSTC from "/disk2/server/proxy-front-ssr/dists/sx/plugins/accessibility.ts";
import image_optimization_g7bmpmlQzE from "/disk2/server/proxy-front-ssr/dists/sx/plugins/image-optimization.ts";
import remove_service_worker_84Q3TGl85a from "/disk2/server/proxy-front-ssr/dists/sx/plugins/remove-service-worker.ts";
import freeze_scroll_client_niXvaKPctK from "/disk2/server/proxy-front-ssr/dists/sx/plugins/freeze-scroll.client.ts";
import preload_client_Hz9sqHSpmn from "/disk2/server/proxy-front-ssr/dists/sx/plugins/preload.client.ts";
import pwa_LR1WDOrRzs from "/disk2/server/proxy-front-ssr/dists/sx/plugins/pwa.ts";
import router_scroll_client_ba1lAMh9cb from "/disk2/server/proxy-front-ssr/dists/sx/plugins/router-scroll.client.ts";
import scrollRestoration_3fVuVJPCgG from "/disk2/server/proxy-front-ssr/dists/sx/plugins/scrollRestoration.ts";
import tooltip_accessibility_AVDrsck4Yp from "/disk2/server/proxy-front-ssr/dists/sx/plugins/tooltip-accessibility.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_UYiXMU8ZyN,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  init_grdyAU8lhf,
  critical_resources_vWgJPk8Gbv,
  error_handler_kEP5FliEXj,
  accessibility_zajbwEjSTC,
  image_optimization_g7bmpmlQzE,
  remove_service_worker_84Q3TGl85a,
  freeze_scroll_client_niXvaKPctK,
  preload_client_Hz9sqHSpmn,
  pwa_LR1WDOrRzs,
  router_scroll_client_ba1lAMh9cb,
  scrollRestoration_3fVuVJPCgG,
  tooltip_accessibility_AVDrsck4Yp
]